import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.4.106c-.3-.195-.8-.098-1.1.098L4.6 3.92H1c-.6 0-1 .39-1 .977v5.866c0 .586.4.978 1 .978h3.6l4.7 3.714c.2.098.4.196.6.196.1 0 .3 0 .4-.098.3-.196.6-.489.6-.88V.986c.1-.39-.1-.684-.5-.88M9 12.62 5.6 9.98c-.2-.097-.4-.195-.6-.195H2v-3.91h3c.2 0 .4-.098.6-.196L9 3.04zm11.4-4.79 2.3-2.248a.93.93 0 0 0 0-1.369.98.98 0 0 0-1.4 0L19 6.46l-2.3-2.248a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37l2.3 2.247-2.3 2.25a.93.93 0 0 0 0 1.367c.2.196.5.294.7.294s.5-.098.7-.294L19 9.2l2.3 2.248c.2.196.5.294.7.294s.5-.098.7-.294a.93.93 0 0 0 0-1.368z"
    }, null, -1)
  ]))]))
}
export default { render: render }